import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { Tooltip, Modal } from 'antd'
import { connect } from 'react-redux'
import { countTokens } from '../../redux-flow/actions/wallet_token'
import FormToken from '../FormToken'

class BoxToken extends Component {

    constructor(props) {
        super(props)
        this.state = {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
        }
    } 

    componentDidMount() {
        // setInterval(() => this.getCountdown(), 1000)
        // const { onLoad } = this.props
        // if(onLoad) {
        //     onLoad()
        // }
    }

    // handleModal = () => {
    //     const { completeToken, onLoad } = this.props
    //     let aux = !this.state.modalToken
    //     if(aux === false && completeToken) {
    //         onLoad()
    //     }
    //     this.setState({ modalToken: aux })
    // }

    getCountdown = () => {
        const time = Date.parse("2022-04-01T00:00:00") - Date.parse(new Date())
        if(time < 0) {
            this.setState({ days: 0, hours: 0, minutes: 0, seconds: 0 })
        } else {
            const seconds = Math.floor((time / 1000) % 60);
            const minutes = Math.floor((time / 1000 / 60) % 60);
            const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
            const days = Math.floor(time / (1000 * 60 * 60 * 24));
            this.setState({ days, hours, minutes, seconds });
        }
    }

    render() {
        const { isLoading, tokens, type } = this.props
        return (
            // <div className="boxToken background-dark-blue">
            //     <div className='boxDisclaimer'>
            //         <small className="tx-pink font-weight-bold">PRE-SALE</small>
            //         <h3 className="boxTitle text-white font-weight-bold mt-1">Adquira já o seu Flow.in Wallet LP Token!</h3>
            //         <div className="infosHolder">
            //         <a href="https://somosflow.in/Flowin Wallet LP Token-2.pdf" target="_blank"><label className="text-white">Acesse o Whitepaper</label></a>&bull;<Tooltip placement='rightTop' title="Para adquirir o seu token, basta ter um endereço Solana e seguir o passo a passo de compra."><label className="text-white">Como comprar</label></Tooltip>
            //         </div>
            //         {/* <label>Clique aqui e acesse nosso Whitepaper</label>
            //         <label>Como adquirir? Para adquirir basta ter um endereço Solana e seguir o passo a passo de compra. Dúvidas em como ter um endereço Solana? Clique aqui e assista nosso tutorial.</label> */}
            //         <div className="offHolder">
            //             {/* <div className="off">
            //                 <div><FontAwesomeIcon icon={faChevronRight} size="2x"/><FontAwesomeIcon icon={faChevronRight}  size="2x" /></div><h3 className="boxSubTitle tx-pink">10%<br /><span>off</span></h3><div><FontAwesomeIcon icon={faChevronLeft}  size="2x"/><FontAwesomeIcon icon={faChevronLeft}  size="2x"/></div>
            //             </div>
            //             <div className="boxDivisor" /> */}
            //             <h4 className='tx-pink mt-5 font-weight-bold'>1 FLWT = R$500,00*</h4>
            //         </div>
            //         <div className="countdown d-flex justify-content-center flex-column align-items-center">
            //             {/* <div className='countdownNumber'>
            //                 {this.state.days}<br /><span>dias</span>
            //             </div>
            //             <div className='countdownNumber'>
            //                 {this.state.hours}<br /><span>horas</span>
            //             </div>
            //             <div className='countdownNumber'>
            //                 {this.state.minutes}<br /><span>minutos</span>
            //             </div>
            //             <div className='countdownNumber'>
            //                 {this.state.seconds}<br /><span>segundos</span>
            //             </div> */}
            //             <h3 className="text-white boxTitle font-weight-bold">Pré-venda encerrada</h3>
            //             <label className="text-white text-center">As vendas continuam normalmente pelo preço ordinário de R$500,00</label>
            //         </div>
            //         {!isLoading && tokens < 1000 ? <button className='btnGrafico' onClick={this.handleModal}>COMPRAR AGORA</button> : <label className='text-white mt-5'>{!isLoading && 'TOKENS ESGOTADOS'}</label>}
            //         <label className="text-white mt-5">Tokens vendidos</label>
            //         {!isLoading && <h1 className="text-white">{tokens} FLWT</h1>}
            //         <div className='salesProgress'>
            //             <div className='salesFill' style={{width: !isLoading && `${(tokens > 1000 ? 1000 : tokens/1000)*100}%`, borderTopRightRadius: tokens >= 100 ? '1000px' : '0px', borderBottomRightRadius: tokens >= 100 ? '1000px' : '0px'}}></div>
            //         </div>
            //         <label className='text-white mt-2'>{!isLoading && tokens > 1000 ? 1000 : tokens}/1000 FLWT</label>
            //     </div>
                
                <Modal
                    visible={this.props.modalToken}
                    onCancel={this.props.handleModal}
                    onClick={this.props.handleModal}
                    footer={false}
                    width={600}
                    maskClosable={false}
                >
                    <FormToken onClick={this.props.handleModal} tokens={tokens} />
                </Modal>
            // </div>
        )
    }
}

const mapStateToProps = state => ({
    isLoading: state.wallet_token.isLoading,
    tokens: state.wallet_token.tokens,
    completeToken: state.wallet_token.completeToken
})

const mapDispatchToProps = dispatch => ({
    onLoad: () => {
        dispatch(countTokens())
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(BoxToken)